var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:[_vm.loading ? 'btn--loading' : '',
                 _vm.onlyIconVisible ? '' : 'btn--' + _vm.theme,
                 'btn--' + this.size,
                 _vm.onlyIconVisible ? 'btn-icon--visible' : '',
                 _vm.fullWidth ? 'btn--full' : '',
                 _vm.fixedWH ? 'btn--fwh' : ''],style:(_vm.customStyle),attrs:{"type":"button","disabled":_vm.disable || _vm.loading},on:{"click":_vm.onClick}},[(this.showIcon)?_c('p4a-icon',{staticClass:"btn-icon",class:_vm.loading ? 'btn--loading' : 'btn--static',style:(_vm.iconStyle),attrs:{"icon":this.icon}}):_vm._e(),_vm._v(" "),(!this.onlyIconVisible)?_c('span',{staticClass:"btn__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-418b0dba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/pro4all-ui/ui-kit/components/Button.vue
// module id = null
// module chunks = 